import { colors } from "../components/templates/dark-hero/colors";

export const SCROLLBAR_TRACK_COLOR = "rgba(255, 255, 255, 0.04)";
export const SCROLLBAR_THUMB_COLOR = colors.primary.main;
export const SCROLLBAR_THUMB_HOVER_COLOR = colors.primary.hover;

export function getScrollbarStyleOverrides() {
  return {
    html: {
      width: "100%",
      overflowX: "hidden",
      scrollbarWidth: "none",
      msOverflowStyle: "none",
    },
    body: {
      margin: 0,
      width: "100%",
    },
    "html::-webkit-scrollbar": {
      display: "none",
      width: 0,
      height: 0,
    },
    "html.lenis, html.lenis body": {
      height: "auto",
    },
    ".lenis.lenis-smooth": {
      scrollBehavior: "auto !important",
    },
  };
}

export function getScrollbarCssText() {
  return `
    html {
      width: 100%;
      overflow-x: hidden;
      scrollbar-width: none;
      -ms-overflow-style: none;
    }

    html::-webkit-scrollbar {
      display: none;
      width: 0;
      height: 0;
    }

    body {
      margin: 0;
      width: 100%;
    }

    html.lenis,
    html.lenis body {
      height: auto;
    }

    .lenis.lenis-smooth {
      scroll-behavior: auto !important;
    }
  `.trim();
}
